import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';
import { link, SanityLink } from './link';

export const awardsCta = groq`{
  _type,
  _key,
  headline,
  bodyCopy,
  button[0] ${link},
  awards[] {
    _key,
    title,
    label,
    link[0] ${link},
    image ${image},
    imageWidth,
  },
}`;

export const SanityAwardsCta = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('awardsCta'),
  _key: z.string(),
  headline: z.string().optional().nullable(),
  bodyCopy: z.string().optional().nullable(),
  button: SanityLink.optional().nullable(),
  awards: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      label: z.string(),
      link: SanityLink.optional().nullable(),
      image: SanityImage,
      imageWidth: z.number(),
    }),
  ),
});

export type SanityAwardsCta = z.infer<typeof SanityAwardsCta>;
